import de from './de.json';
import en from './en.json';
import es from './es.json';
import zhHans from './zh-Hans.json';
import zhHant from './zh-Hant.json';

const i18nResources = {
    de: {
        translation: de,
    },
    en: {
        translation: en,
    },
    es: {
        translation: es,
    },
    'zh-Hans': {
        translation: zhHans,
    },
    'zh-Hant': {
        translation: zhHant,
    },
};

export default i18nResources;
